import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminLawnMowerEdit from "@/pages/admin/AdminLawnMowerEdit";

export const Route = createFileRoute("/admin/lawn-mowers/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminLawnMowerEdit />
    </ProtectedRoute>
  ),
});
